import React from 'react';

import './CornerCloseButton.css';

const CornerCloseButton = ({ onClick, className = '', disabled, ...rest }) => {
  return (
    <button
      onClick={onClick}
      aria-label='Close modal'
      className={`corner-close-button ${className}`}
      disabled={disabled}
      {...rest}
    >
      &times;
    </button>
  );
};

export default CornerCloseButton;
